import debounce from '../utils/debounce';

const QUERY = '.site-header';


/**
 * This feature is used to set header behavior
 * 
 * @class Header
 * @param {string} [query]
 * @param {number} [offset]
 * @param {string} [type]
 */

export default class Header {
    constructor(query = QUERY, offset = 0, type = 'sticky') {
        this.query = query;

        const el = document.querySelector(this.query);
        if (!el) throw new Error('Header not found');

        this.header = el;
        this.type = type;
        this.offset = offset;

        const head = document.head || document.querySelector('head');
        this.head = head || null;

        this.init();
    }

    init() {

        if (this.type === 'sticky') this.sticky();
    }

    sticky() {
        const gth = this;

        this.header.classList.add('sticky');

        let prev = 0;
        window.addEventListener('scroll', (event) => {
            event.stopPropagation();

            (debounce(function () {
                const current = window.scrollY || window.pageYOffset;

                if (window.scrollY > gth.offset) {
                    if (prev < current) {
                        gth.header.classList.remove('sticky');
                    } else {
                        gth.header.classList.add('sticky');
                    }
                } else {
                    gth.header.classList.add('sticky');
                }

                prev = current;
            }))();
        });
    }
}

/**
 * Usage example
 * 
 * const header = new Header('.header', 50, 'sticky');
 * 
 * or
 * 
 * const header = new Header('.header');
 * 
 */
